export const LIST_OFFICE = "LIST_OFFICE";
export const SELECTED_COMUNA = "SELECTED_COMUNA";
export const LOADING_COMUNA = "LOADING_COMUNA";
export const SELECTED_SUCURSAL = "SELECTED_SUCURSAL";
export const CHANGE_URL_MAPA = "CHANGE_URL_MAPA";